export enum Side {
  Debit = 'debit',
  Credit = 'credit',
}
